<div class="s11-margin betting-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Tippspiel</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p>Dein Tipp für das nächste Spiel:</p>
      <div class="result-bet" style="width: 100%">
        <mat-form-field style="min-width: 50px">
          <mat-label>{{ nextBet?.home }}</mat-label>
          <input
            [s11OnlyNumber]="true"
            type="number"
            min="0"
            max="100"
            matInput
            [disabled]="isFrozen()"
            (change)="setHomeScore($event)"
            [value]="homeScore()" />
        </mat-form-field>
        <span>
          <mat-icon aria-hidden="false" aria-label=":" fontIcon="go_to_line" />
        </span>
        <mat-form-field style="min-width: 50px">
          <mat-label>{{ nextBet?.away }}</mat-label>
          <input
            [s11OnlyNumber]="true"
            type="number"
            min="0"
            max="100"
            matInput
            [disabled]="isFrozen()"
            (change)="setAwayScore($event)"
            [value]="awayScore()" />
        </mat-form-field>
      </div>
      <p>
        <button
          mat-flat-button
          color="primary"
          (click)="submitBet()"
          [disabled]="isFrozen()">
          Tipp abgeben / ändern
        </button>
      </p>
    </mat-card-content>
  </mat-card>
</div>
